import api from "../global/Api";

export const downloadTestPdf = async () => {
  const response = await api.get("/pdf-service/test?bookingReference=test", {
    responseType: "blob",
  });
  return response.data;
};

export const downloadTestWord = async () => {
  const response = await api.get("/word-service/test?language=PT", {
    responseType: "blob",
  });
  return response.data;
};
